var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 17L4.16667 4.16667L29.8333 4.16667L29.8333 17H33.5V4.16667C33.5 2.15 31.85 0.5 29.8333 0.5L4.16667 0.5C2.15 0.5 0.5 2.15 0.5 4.16667V17H4.16667ZM15.1667 15.7717L10.4183 20.5017L7.83333 17.9167L17 8.75L26.1667 17.9167L23.5817 20.5017L18.8333 15.7717L18.8333 33.5H15.1667L15.1667 15.7717Z",
    fill: "#1565D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.6c9566fa77183172b1839073f8966a9c.svg";
export { ForwardRef as ReactComponent };